var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"text-center m-3"},[_c('b-spinner',{attrs:{"variant":_vm.variant,"label":_vm._f("translate")('common.loading')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }